class YandexMap{
    constructor(){
        this.map = null;
        this.init();
    }

    create(){

        this.map = new ymaps.Map('map', {
            center: [55.534372,28.645622],
            zoom: 15,
            controls: ['zoomControl', 'fullscreenControl'],
        }, {
            searchControlProvider: 'yandex#search',
        });

        this.map.behaviors.disable('scrollZoom');

        this.map.geoObjects
            .add(new ymaps.Placemark([55.534372,28.645622],{
                balloonContent: 'Республика Беларусь, г. Новополоцк, ул. Молодежная, 74.'},{ iconColor: '#5134ad' }));
    }
    init(){
        const locationPathName = window.location.pathname
        if(!locationPathName.includes('/contacts')){
            return false;
        }
        let scriptMap = document.createElement('script');
        scriptMap.type = 'text/javascript';
        scriptMap.src = '//api-maps.yandex.ru/2.1/?lang=ru_RU&amp;apikey=e7c90147-ab2e-498c-aedb-934514bda192&onload=map.create';
        document.querySelector('body').appendChild(scriptMap);
    }
}
window.map = new YandexMap();
